import HyperEntity from "@shared/backend/hyper-entity.decorator";
import { Fields, Relations } from "remult";
import { extender } from "../../backend/class-extender";
import { AssociationPositionFilters } from "./filters";
import { AssociationPositionMethods } from "./methods";
import { AssociationPositionEntityConfig } from "./config";
import { SubCategory } from "../sub-category";
import { Association } from "../association/entity";

@HyperEntity("association-position", AssociationPositionEntityConfig)
export class AssociationPosition extends extender(
  AssociationPositionFilters,
  AssociationPositionMethods,
) {
  @Relations.toOne(() => SubCategory, "subCategoryId")
  subCategory?: SubCategory;

  @Relations.toOne(() => Association, "associationId")
  association?: Association;

  @Fields.string({ dbName: "sub_category_id" })
  subCategoryId = "";

  @Fields.string({ dbName: "association_id" })
  associationId = "";

  @Fields.createdAt({ dbName: "created_at" })
  createdAt? = new Date();

  @Fields.updatedAt({ dbName: "updated_at" })
  updatedAt? = new Date();
}
